import { PluginKey } from '@tiptap/pm/state';

const LIVEBLOCKS_MENTION_KEY = new PluginKey("lb-plugin-mention");
const LIVEBLOCKS_MENTION_PASTE_KEY = new PluginKey(
  "lb-plugin-mention-paste"
);
const LIVEBLOCKS_MENTION_NOTIFIER_KEY = new PluginKey(
  "lb-plugin-mention-notify"
);
const LIVEBLOCKS_MENTION_EXTENSION = "liveblocksMentionExt";
const LIVEBLOCKS_MENTION_TYPE = "liveblocksMention";
const THREADS_ACTIVE_SELECTION_PLUGIN = new PluginKey(
  "lb-threads-active-selection-plugin"
);
const THREADS_PLUGIN_KEY = new PluginKey(
  "lb-threads-plugin"
);
const AI_TOOLBAR_SELECTION_PLUGIN = new PluginKey(
  "lb-ai-toolbar-selection-plugin"
);
const LIVEBLOCKS_COMMENT_MARK_TYPE = "liveblocksCommentMark";
var ThreadPluginActions = /* @__PURE__ */ ((ThreadPluginActions2) => {
  ThreadPluginActions2["SET_SELECTED_THREAD_ID"] = "SET_SELECTED_THREAD_ID";
  return ThreadPluginActions2;
})(ThreadPluginActions || {});

export { AI_TOOLBAR_SELECTION_PLUGIN, LIVEBLOCKS_COMMENT_MARK_TYPE, LIVEBLOCKS_MENTION_EXTENSION, LIVEBLOCKS_MENTION_KEY, LIVEBLOCKS_MENTION_NOTIFIER_KEY, LIVEBLOCKS_MENTION_PASTE_KEY, LIVEBLOCKS_MENTION_TYPE, THREADS_ACTIVE_SELECTION_PLUGIN, THREADS_PLUGIN_KEY, ThreadPluginActions };
//# sourceMappingURL=types.js.map
